import { Component, computed, inject, input, output } from '@angular/core';
import { DynamicTranslationService } from '@gs-2.0/core';

const MAX_HEADING_CHARS = 60;

@Component({
  selector: 'app-closing-cta',
  standalone: false,
  templateUrl: './closing-cta.component.html',
  styleUrl: './closing-cta.component.scss'
})
export class ClosingCtaComponent {
  private translationService = inject(DynamicTranslationService);

  /**
   * Translation key for the main heading
   */
  heading = input<string>('home.cta.heading');

  headingDisplay = computed(() => {
    const text = this.translationService.instant(this.heading());
    return text.length > MAX_HEADING_CHARS ? text.slice(0, MAX_HEADING_CHARS) + '...' : text;
  });

  /**
   * Translation key for the subtext
   */
  subtext = input<string>('home.cta.subtext');

  /**
   * Translation key for the button label
   */
  buttonLabel = input<string>('home.cta.button');

  /**
   * Background image URL for the people section
   */
  peopleImageUrl = input<string>('/assets/images/home/Bottom.png');

  /**
   * Background image URL for the CTA banner
   */
  bannerImageUrl = input<string | null>(null);

  /**
   * Controls visibility of the image section
   */
  showImageSection = input<boolean>(true);

  /**
   * Optional color override for the heading text
   */
  headingColor = input<string | null>(null);

  /**
   * Optional color override for the subtext
   */
  subtextColor = input<string | null>(null);

  /**
   * Optional URL to navigate to when the button is clicked.
   * When provided, the component opens the URL directly.
   * When null, the buttonClicked output is emitted for the parent to handle.
   */
  buttonLink = input<string | null>(null);

  /**
   * Emits when the CTA button is clicked and no buttonLink is provided
   */
  buttonClicked = output<void>();

  onButtonClick(): void {
    const link = this.buttonLink();
    if (link) {
      const url = /^https?:\/\//i.test(link) ? link : `https://${link}`;
      window.open(url, '_blank');
    } else {
      this.buttonClicked.emit();
    }
  }
}
